import type { FeatureModule } from '@/shell/registry/types'
import { ARCH_PATHS, architectureLocation, architectureRouteQuery } from './semanticRoutes'

export default {
  code: 'architecture',
  title: '架构管理',
  provides: {
    /** 语义化路由定位函数：由 query 生成 /arch 路由 location，供产研等模块跳转架构对象 */
    'architecture.location': architectureLocation,
  },
  routes: [
    { path: '/arch/standards/knowledge', redirect: to => ({ path: '/arch/standards/workflow', query: to.query }) },
    { path: '/arch', redirect: '/arch/overview' },
    ...Object.values(ARCH_PATHS).map(c => ({
      path: '/arch/' + c.path + '/:section?/:objectCode?',
      component: () => import('./ArchBrowser.vue'),
      meta: { tab: 'arch', title: c.title },
      beforeEnter: (to: any) => architectureRouteQuery(to.path, to.query) ? true : '/not-found'
    })),
  ],
} satisfies FeatureModule
